import React, { useRef } from 'react';
import builder from '@rsql/builder';
import { InputText } from 'primereact/inputtext';
import BasePage from '../../../../core/page/BasePage';
import BaseFilter from '../../../../core/page/components/baseFilter/BaseFilter';
import AutoCompleteDropDown from '../../../../core/components/inputs/AutoCompleteDropDown';
import InputDropDown from '../../../../core/components/inputs/inputDropDown/InputDropDown';
import { useInputs } from '../../../../core/utils/Hooks';
import ConfirmDialog from '../../../../core/components/ConfirmDialog';
import Pages from '../../../../config/Pages';
import { inputsIndicador } from '../PageInputs';
import RotuloSeplag from '../../../../components/rotuloSeplag/RotuloSeplag';
import styles from './IndicadorListagem.module.scss';
import { useOrgao } from '../../Utils';
import indicadorService from '../../../../service/IndicadorService';
import orgaoIntegracaoService from '../../../../service/integracao/OrgaoIntegracaoService';
import tipoIndicadorService from '../../../../service/TipoIndicadorService';
import situacaoIndicadorService from '../../../../service/SituacaoIndicadorService';
import ModalJustificativaInativacao from '../components/modalJustificativaInativacao/ModalJustificativaInativacao';
import ActionButtons from '../components/ActionButtons';

function IndicadorListagem() {
    const orgaoUsuarioLogado = useOrgao();
    const filterInputs = useInputs(inputsIndicador);
    const confirmRef = useRef(null);
    const formRef = useRef(null);
    const modalInativarRef = useRef(null);

    const Rotulo = ({ children, ...rest }) => (
        <RotuloSeplag useInput={filterInputs} {...rest}>
            {children}
        </RotuloSeplag>
    );

    const Inputs = ({ formik }) => {
        return (
            <>
                <Rotulo cols="12">
                    <AutoCompleteDropDown
                        name="orgao"
                        formik={formik}
                        field="descOrgao"
                        disabled={orgaoUsuarioLogado?.siglOrgao !== 'SEPLAG'}
                        service={orgaoIntegracaoService.autoComplete.bind(orgaoIntegracaoService)}
                    />
                </Rotulo>
                <Rotulo cols="12 4">
                    <InputText
                        name="codgIndicador"
                        value={formik.values.codgIndicador}
                        onChange={formik.handleChange}
                    />
                </Rotulo>
                <Rotulo cols="12 4">
                    <InputText
                        name="nmIndicador"
                        value={formik.values.nmIndicador}
                        onChange={formik.handleChange}
                    />
                </Rotulo>
                <Rotulo cols="12 4">
                    <InputText
                        name="responsavel"
                        value={formik.values.responsavel}
                        onChange={formik.handleChange}
                    />
                </Rotulo>
                <Rotulo cols="12 4">
                    <InputDropDown
                        name="situacao"
                        formik={formik}
                        optionLabel="descSituacaoIndicador"
                        valueIsCompleteObject
                        callbackSetList={situacaoIndicadorService.list.bind(
                            situacaoIndicadorService
                        )}
                    />
                </Rotulo>
                <Rotulo cols="12 4">
                    <InputDropDown
                        name="tipoIndicador"
                        formik={formik}
                        valueIsCompleteObject
                        optionLabel="descTipoIndicador"
                        callbackSetList={tipoIndicadorService.list.bind(tipoIndicadorService)}
                    />
                </Rotulo>
            </>
        );
    };

    return (
        <>
            <ModalJustificativaInativacao
                ref={modalInativarRef}
                onSave={({ success }) => {
                    if (success) {
                        modalInativarRef.current?.hide();
                    }
                }}
            />
            <ConfirmDialog ref={confirmRef} />
            <BasePage
                service={indicadorService}
                className={styles.page}
                enableAdicionar={false}
                page={{
                    pageUrls: Pages.sei.indicador.url,
                    legenda: Pages.sei.indicador.legenda,
                    pageName: Pages.sei.indicador.title,
                }}
                initialValues={inputsIndicador.filter((input) => input?.table?.use ?? false)}
                enableAlterar={false}
                enableExcluir={false}
                enableVisualizar={false}
                enableEditar={false}
                addAfterActions={(data) => (
                    <ActionButtons
                        data={data}
                        confirmRef={confirmRef}
                        modalInativarRef={modalInativarRef}
                    />
                )}
            >
                <BaseFilter
                    ref={formRef}
                    initialValues={inputsIndicador.filter((input) => input?.filter?.use ?? false)}
                    prepareInitialValues={async (dados) => ({
                        ...dados,
                        orgao: orgaoUsuarioLogado,
                    })}
                    noEmptyInputsOnClear={orgaoUsuarioLogado?.siglOrgao === 'SEPLAG'}
                    customFilter={{
                        orgao: ({ nameUse, original }) =>
                            builder.comparison(nameUse, '==', original?.idenOrgao),
                        situacao: ({ nameUse, original }) =>
                            builder.comparison(nameUse, '==', original?.id),
                        tipoIndicador: ({ nameUse, original }) =>
                            builder.comparison(nameUse, '==', original?.id),
                    }}
                >
                    <Inputs />
                </BaseFilter>
            </BasePage>
        </>
    );
}

export default IndicadorListagem;
